const ACCESS_TOKEN = localStorage.getItem('pesaapi@user');
// const apiHost = 'https://funugapi.qubitsanalytic.com/funug-api/'
const apiHost = 'http://localhost:9554/funug-api/'

export default {

    async loginUser(username, password) {

        let data = {
            "username": username,
            "password": password,
        }

        try {
            let response = await fetch(apiHost + 'user/login',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data),
                });
            let result = await response.json();

            //console.log("llllllllllllllllll",result)

            return result;
        } catch (error) {
            console.log(error)
            let connError = { 'status': 'conn', 'details': { 'message': 'Contacting server....', 'content': false } }
            // console.log("mmmmmmmmmmmmmmmmmmm",error)
            return connError;
        }

    },

}